import React from "react";
import { Loader2 } from "lucide-react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export const inputCls =
  "w-full rounded-xl border-2 border-stone-200 bg-stone-50 px-4 py-2.5 text-base text-leaf-900 placeholder:text-stone-400 focus:border-leaf-500 focus:bg-white focus:outline-none focus:ring-4 focus:ring-leaf-200 transition";

export function Loader() {
  return (
    <div className="flex items-center justify-center py-12 text-leaf-700">
      <Loader2 className="h-6 w-6 animate-spin" />
    </div>
  );
}

export function ErrorBox({ msg }) {
  return (
    <div className="rounded-2xl bg-clay-500/10 px-4 py-3 text-sm text-clay-600">
      {msg}
    </div>
  );
}

export function EmptyState({ icon: Icon, label }) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-2xl border-2 border-dashed border-leaf-200 bg-leaf-50/40 py-14 text-leaf-900/60">
      <Icon className="h-8 w-8" />
      <p className="font-semibold">{label}</p>
    </div>
  );
}

export function Field({ label, children, full = false }) {
  return (
    <label className={`block ${full ? "sm:col-span-2" : ""}`}>
      <span className="mb-1.5 block text-sm font-semibold text-leaf-900">{label}</span>
      {children}
    </label>
  );
}
